import { render, staticRenderFns } from "./RichTextLenderBox.vue?vue&type=template&id=33d3e5e7&scoped=true&"
import script from "./RichTextLenderBox.vue?vue&type=script&lang=js&"
export * from "./RichTextLenderBox.vue?vue&type=script&lang=js&"
import style0 from "./RichTextLenderBox.vue?vue&type=style&index=0&id=33d3e5e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d3e5e7",
  null
  
)

export default component.exports